import type { VariantProps } from 'class-variance-authority';

import * as React from 'react';
import { Slot } from 'radix-ui';
import { cva } from 'class-variance-authority';

import { cn } from '@shared/utils/cn';

// Remplace Chip : small 24px (rayon 8) / medium 32px (rayon 10), label 13px medium
const badgeVariants = cva(
  'inline-flex shrink-0 items-center justify-center gap-1 font-medium whitespace-nowrap [&>svg]:pointer-events-none [&>svg]:size-3.5',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground',
        soft: 'bg-primary/16 text-primary',
        secondary: 'bg-muted-foreground/16 text-foreground',
        outline: 'border border-input text-foreground',
        success: 'bg-success/16 text-success',
        warning: 'bg-warning/16 text-warning',
        destructive: 'bg-destructive/16 text-destructive',
      },
      size: {
        sm: 'h-6 rounded-lg px-1.5 text-xs',
        default: 'h-8 rounded-[10px] px-2.5 text-[13px]',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  }
);

type BadgeProps = React.ComponentProps<'span'> & VariantProps<typeof badgeVariants> & { asChild?: boolean };

const Badge = ({ className, variant, size, asChild = false, ...props }: BadgeProps) => {
  const Comp = asChild ? Slot.Root : 'span';

  return <Comp className={cn(badgeVariants({ variant, size }), className)} data-slot="badge" {...props} />;
};

export type { BadgeProps };
export { Badge, badgeVariants };
